module.exports = __webpack_public_path__ + "img/movie10.0c8cf1f5.png";